const expand = {
  namespaced: true,
  state: {
    operateList: [
      {
        icon: "el-icon-postcard",
        name: "指令中心",
        type: 1,
      },
      {
        icon: "el-icon-document",
        name: "问题集锦",
        type: 2,
      },
      {
        icon: "el-icon-notebook-2",
        name: "参考依据",
        type: 3,
      },
    ],
    expandAreaVisible: false,
    expandType: "",
    expandContent: "",
    expandContentObject: null,
    expandTitle: "",
    expandAreaWidth: 376,
    expandAreaMaxWidth: 720,
    expandAreaMinWidth: 376,
    showExpandHeader: true,
    expandLoading: false,
  },
  mutations: {
    setExpandType(state, type) {
      state.expandType = type;
    },
    setShowExpandHeader(state, show) {
      state.showExpandHeader = show;
    },
    setExpandContent(state, content) {
      state.expandContent = content;
    },
    setExpandContentObject(state, contentObject) {
      state.expandContentObject = contentObject;
    },
    setExpandTitle(state, title) {
      state.expandTitle = title;
    },
    setExpandAreaVisible(state, visible) {
      state.expandAreaVisible = visible;
    },
    setMaxWidthToWidth(state) {
      state.expandAreaWidth = state.expandAreaMaxWidth;
    },
    setMinWidthToWidth(state) {
      state.expandAreaWidth = state.expandAreaMinWidth;
    },
    setExpandLoading(state, loading) {
      state.expandLoading = loading;
    },
  },
  actions: {
    setExpandType({ commit }, type) {
      commit("setExpandType", type);
    },
    setExpandContent({ commit }, content) {
      commit("setExpandContent", content);
    },
    setExpandContentObject({ commit }, contentObject) {
      commit("setExpandContentObject", contentObject);
    },
    setExpandTitle({ commit }, title) {
      commit("setExpandTitle", title);
    },
    setExpandAreaTitleContent({ commit }, { title, content }) {
      commit("setExpandTitle", title);
      commit("setExpandContent", content);
    },
    openExpandArea({ commit }) {
      commit("setExpandAreaVisible", true);
    },
    setShowExpandHeader({ commit }, show) {
      commit("setShowExpandHeader", show);
    },
    closeExpandArea({ commit }) {
      commit("setExpandContent", "");
      commit("setExpandTitle", "");
      commit("setExpandType", null);
      commit("setExpandAreaVisible", false);
      commit("setShowExpandHeader", true);
    },
    setExpandAreaWidth({ commit }, type) {
      switch (type) {
        case "max":
          commit("setMaxWidthToWidth");
          break;
        case "min":
          commit("setMinWidthToWidth");
          break;
        default:
          commit("setMinWidthToWidth");
          break;
      }
    },
    setExpandLoading({ commit }, loading) {
      commit("setExpandLoading", loading);
    },
  },
  getters: {},
};

export default expand;
